import React from 'react'
import AutoCompleteSelect from '../UI/AutoCompleteSelect'

import Resource from '../../stores/resource'
const CostFormulaStore = Resource('cost-formulas')
const RateFormulaStore = Resource('rate-formulas')


const CostFormulaSelect = (props) => (
  <AutoCompleteSelect
    name={props.name || 'costFormula'}
    value={props.value}
    floatingLabelText='Select a cost formula (autocomplete)'
    selectedId={props.selectedId}
    dataStore={CostFormulaStore}
    autoCompleteFilter='nameAutocomplete'
    autoCompleteAttribute='name'
    validatedOnChange={props.validatedOnChange}
    fullWidth={true}
    required={props.required}
    openOnFocus={true}
  />
)

const RateFormulaSelect = (props) => (
  <AutoCompleteSelect
    name={props.name || 'rateFormula'}
    value={props.value}
    floatingLabelText='Select a rate formula (autocomplete)'
    selectedId={props.selectedId}
    dataStore={RateFormulaStore}
    autoCompleteFilter='nameAutocomplete'
    autoCompleteAttribute='name'
    validatedOnChange={props.validatedOnChange}
    fullWidth={true}
    required={props.required}
    openOnFocus={true}
  />
)

export {
  CostFormulaSelect,
  RateFormulaSelect
}



// WEBPACK FOOTER //
// ./src/components/Formulas/FormulaSelects.jsx